import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
/**
 * Txp options settings
 */
let AgendaMailOption: LazyOption = createLazyOption(
    {
        key: 'agenda',
        titleStringKey: 'optionTitle_AgendaMail',
        searchTermsStringKey: 'optionTitle_AgendaMail',
        hideTitleInFullOptions: true,
        isHidden: () => !isFeatureEnabled('cal-mf-agendaMailOption'),
        allowedOptionKeys: ['AgendaMail'],
    },
    lazyFullModule,
    m => m.default
);
export default AgendaMailOption;
